import React from 'react';
import NoResults from './../no_results/noResultsComponent';

class Undergraduate extends React.Component {

  render() {
    var data = this.props.data || [];

    return <div className="accordions type-2">
      <h6 className="heading">Undergraduate degrees</h6>
      {
        data.length > 0 ? data.map((item, i) => { return this.props.createAccordion(item, i); }, this)
          : <NoResults name={'Undergraduate'} />
      }

    </div>;
  }
}

Undergraduate.propTypes = {
  data: React.PropTypes.array.isRequired
};

export default Undergraduate;
